export default "__VITE_ASSET__jXVqYR10__"